module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/fr.json
// module id = 560
// module chunks = 0